export var WORKSPACE_MAIN_RESET = 'WORKSPACE_MAIN_RESET';
export var WORKSPACE_MAIN_SET_USER = 'WORKSPACE_MAIN_SET_USER';
export var WORKSPACE_MAIN_SET_USER_PROFILE = 'WORKSPACE_MAIN_SET_USER_PROFILE';
export var WORKSPACE_MAIN_SET_USER_ORGANIZATION_ROLES = 'WORKSPACE_MAIN_SET_USER_ORGANIZATION_ROLES';
export var WORKSPACE_MAIN_SET_USER_EVENT_ROLES = 'WORKSPACE_MAIN_SET_USER_EVENT_ROLES';
export var WORKSPACE_MAIN_SET_ORGANIZATIONS = 'WORKSPACE_MAIN_SET_ORGANIZATIONS';
export var WORKSPACE_MAIN_SET_EVENTS = 'WORKSPACE_MAIN_SET_EVENTS';
export var resetWorkspaceMain = function () {
    return {
        type: WORKSPACE_MAIN_RESET,
    };
};
export var setWorkspaceMainUser = function (user) {
    return {
        type: WORKSPACE_MAIN_SET_USER,
        payload: { user: user },
    };
};
export var setWorkspaceMainUserProfile = function (userProfile) {
    return {
        type: WORKSPACE_MAIN_SET_USER_PROFILE,
        payload: { userProfile: userProfile },
    };
};
export var setWorkspaceMainUserOrganizationRoles = function (userOrganizationRoles) {
    return {
        type: WORKSPACE_MAIN_SET_USER_ORGANIZATION_ROLES,
        payload: { userOrganizationRoles: userOrganizationRoles },
    };
};
export var setWorkspaceMainUserEventRoles = function (userEventRoles) {
    return {
        type: WORKSPACE_MAIN_SET_USER_EVENT_ROLES,
        payload: { userEventRoles: userEventRoles },
    };
};
export var setWorkspaceMainOrganizations = function (organizations) {
    return {
        type: WORKSPACE_MAIN_SET_ORGANIZATIONS,
        payload: { organizations: organizations },
    };
};
export var setWorkspaceMainEvents = function (events) {
    return {
        type: WORKSPACE_MAIN_SET_EVENTS,
        payload: { events: events },
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/reducers/workspaceMain/actions.ts
// module id = 184
// module chunks = 0